<div class="company-suspension-warning-text select-none" *ngIf="isVisible">
  <button type="button" class="company-suspension-warning-dismiss" (click)="dismiss()" aria-label="Dismiss">×</button>
  <div>Your company is suspended from working with us.</div>
  <div class="company-suspension-warning-subtext">Please contact a LoHi representative to reactivate your account.</div>
</div>
